import { render } from "./DataGridTable.vue?vue&type=template&id=6ffa59b1&scoped=true"
import script from "./DataGridTable.vue?vue&type=script&lang=js"
export * from "./DataGridTable.vue?vue&type=script&lang=js"

import "./DataGridTable.vue?vue&type=style&index=0&id=6ffa59b1&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffa59b1"]])

export default __exports__